import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { MarcaVeiculo } from "../typings";

export function useListarMarcasVeiculo() {
  return useQuery<MarcaVeiculo[], AxiosError>(
    "/v1/veiculo/marcas",
    async () => {
      const {data} = await http.get<MarcaVeiculo[]>(`/v1/veiculo/marcas`);

      return data;
    }
  );
}
